import React from 'react'
import log from 'sentry/log'
import ErrorComponent from 'components/sharedComponents/ErrorComponent'

// Error boundaries are React components that catch JavaScript errors anywhere in their child component tree,
// Error boundaries catch errors during rendering, in lifecycle methods, inside Hooks like useEffect, in constructors, of the whole tree below them.
// https://reactjs.org/docs/error-boundaries.html
// there is no equivalent to componentDidCatch when using hooks yet..
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    log.error(error, { errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return <ErrorComponent error="500" />
    }
    return this.props.children
  }
}

export default ErrorBoundary
